(() => {
  // Lokalny debounce (żeby nie zależeć od utility.js)
  function debounce(fn, wait) {
    let t = null;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  // 1) Upewnij się, że bazowy SearchForm istnieje globalnie (dla predictive-search.js)
  //    UWAGA: nie używamy "class SearchForm" w globalu, żeby uniknąć redeclare.
  const BaseSearchForm =
    window.SearchForm ||
    class extends HTMLElement {
      constructor() {
        super();
        this.input = null;
        this.resetButton = null;

        this._bound = false;
        this._onInput = null;
        this._onReset = null;
        this._onClickReset = null;
      }

      connectedCallback() {
        // Shopify potrafi re-renderować sekcje → nie binduj 2x
        if (this._bound) return;
        this._bound = true;

        this.input = this.querySelector('input[type="search"], input[name="q"], input');
        this.resetButton = this.querySelector('button[type="reset"], [data-search-reset]');

        const form = this.input ? (this.input.form || this.closest('form')) : this.closest('form');
        if (!this.input || !form) return;

        this._onInput = debounce(() => this.onChange(), 200);
        this._onReset = (e) => this.onFormReset(e);

        this.input.addEventListener('input', this._onInput);
        form.addEventListener('reset', this._onReset);

        // Jeśli w jakimś miejscu reset jest buttonem a nie type="reset"
        if (this.resetButton && this.resetButton.type !== 'reset') {
          this._onClickReset = () => {
            try {
              form.reset();
            } catch (e) {}
          };
          this.resetButton.addEventListener('click', this._onClickReset);
        }

        this.toggleResetButton();
      }

      disconnectedCallback() {
        const form = this.input ? (this.input.form || this.closest('form')) : this.closest('form');

        if (this.input && this._onInput) this.input.removeEventListener('input', this._onInput);
        if (form && this._onReset) form.removeEventListener('reset', this._onReset);
        if (this.resetButton && this._onClickReset) this.resetButton.removeEventListener('click', this._onClickReset);

        this._bound = false;
      }

      toggleResetButton() {
        if (!this.resetButton || !this.input) return;

        const show = (this.input.value || '').trim().length > 0;

        if (show) {
          this.resetButton.classList.remove('hidden');
          this.resetButton.removeAttribute('hidden');
          this.resetButton.setAttribute('aria-hidden', 'false');
        } else {
          this.resetButton.classList.add('hidden');
          this.resetButton.setAttribute('hidden', '');
          this.resetButton.setAttribute('aria-hidden', 'true');
        }
      }

      onChange() {
        this.toggleResetButton();
      }

      shouldResetForm() {
        // Jak user kliknął wynik predictive search (aria-selected), nie czyścimy “na chama”
        return !this.querySelector('[aria-selected="true"] a');
      }

      onFormReset(event) {
        // Prevent default żeby reset nie ładował wartości z URL na starcie
        if (event) event.preventDefault();

        if (!this.input) return;

        if (this.shouldResetForm()) {
          this.input.value = '';
          this.input.focus();
          this.toggleResetButton();
        }
      }
    };

  window.SearchForm = BaseSearchForm;

  // 2) Zarejestruj custom element tylko raz
  if (!customElements.get('search-form')) {
    customElements.define('search-form', BaseSearchForm);
  }
})();
